import { sentryWrappedException } from "~/utils/Utils";

// Used to trigger a typescript error if a switch statement is not exhaustive (see wallet_reducer.ts for example usage)
// eslint-disable-next-line import/prefer-default-export,@typescript-eslint/no-unused-vars
export const exhaustiveMatchGuard = (_: never): never => {
  const error = new Error("No matching action type");
  sentryWrappedException(error);
  throw error;
};
